function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1A6.51 6.51 0 0 0 1 7.5 6.51 6.51 0 0 0 7.5 14 6.51 6.51 0 0 0 14 7.5 6.51 6.51 0 0 0 7.5 1zm0 1C10.543 2 13 4.457 13 7.5S10.543 13 7.5 13A5.493 5.493 0 0 1 2 7.5C2 4.457 4.457 2 7.5 2zM7 3v5h3V7H8V3z",
    transform: "scale(16)",
    fill: "#606060",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }));
};
export default SvgClock;